export default __webpack_public_path__ + "static/media/article_default_img.9a6370fd.png";